// Alma ERP — عميل الـ API (نفس الأصل؛ الجلسة بالكوكي)
import axios from "axios";

const api = axios.create({ baseURL: typeof window !== "undefined" ? window.location.origin : "", withCredentials: true, headers: { "Content-Type": "application/json" } });
api.interceptors.response.use((r) => r, async (error) => {
  const cfg = error.config || {};
  if (error.response?.status === 401 && typeof window !== "undefined" && !/\/auth\/(me|logout)/.test(String(cfg.url || "")) && !window.location.pathname.startsWith("/login")) window.location.replace("/login?error=session_ended");
  if (error.response?.status === 429 && (!cfg._retry || cfg._retry < 3)) { cfg._retry = (cfg._retry || 0) + 1; await new Promise((r) => setTimeout(r, 1000 * Math.pow(2, cfg._retry))); return api(cfg); }
  return Promise.reject(error);
});

export const auth = {
  getUser: () => api.get("/auth/me"),
  logout: () => api.post("/auth/logout"),
  loginUrl: "/auth/google",
};

export const users = {
  list: () => api.get("/api/users"),
  invite: (d) => api.post("/api/users", d),
  update: (id, d) => api.put(`/api/users/${id}`, d),
  audit: () => api.get("/api/users/audit"),
};

export const alma = {
  messages: (params) => api.get("/api/alma/messages", { params }),
  updateMessage: (id, d) => api.put(`/api/alma/messages/${id}`, d),
  deleteMessage: (id) => api.delete(`/api/alma/messages/${id}`),
  settings: () => api.get("/api/alma/settings"),
  saveSettings: (d) => api.put("/api/alma/settings", d),
  compliance: () => api.get("/api/alma/compliance"),
  saveCompliance: (key, d) => api.put(`/api/alma/compliance/${key}`, d),
  verifyCompliance: (key) => api.post(`/api/alma/compliance/${key}/verify`, {}, { timeout: 60000 }),
  verifyAllCompliance: () => api.post("/api/alma/compliance/verify-all", {}, { timeout: 120000 }),
  people: () => api.get("/api/alma/people"),
  createPerson: (d) => api.post("/api/alma/people", d),
  updatePerson: (id, d) => api.put(`/api/alma/people/${id}`, d),
  deletePerson: (id) => api.delete(`/api/alma/people/${id}`),
  startupReqs: () => api.get("/api/alma/startup-reqs"),
  createStartupReq: (d) => api.post("/api/alma/startup-reqs", d),
  updateStartupReq: (id, d) => api.put(`/api/alma/startup-reqs/${id}`, d),
  deleteStartupReq: (id) => api.delete(`/api/alma/startup-reqs/${id}`),
  startupReqDoc: (id) => api.get(`/api/alma/startup-reqs/${id}/doc`, { responseType: "blob" }),
  addStartupItem: (id, text) => api.post(`/api/alma/startup-reqs/${id}/items`, { text }),
  updateStartupItem: (id, iid, d) => api.put(`/api/alma/startup-reqs/${id}/items/${iid}`, d),
  deleteStartupItem: (id, iid) => api.delete(`/api/alma/startup-reqs/${id}/items/${iid}`),
  siteContent: () => api.get("/api/alma/content"),
  saveSiteContent: (items) => api.put("/api/alma/content", { items }),
};

export default api;
